import { Injectable, Inject } from '@angular/core';
import { Resolve } from '@angular/router';
import { SensorService } from '../service';

@Injectable({
  providedIn: 'root'
})
export class GetAllSensorAllocationsResolver implements Resolve<any> {

  constructor(private sensorService: SensorService) { }

  resolve() {
    return this.sensorService.getAddSensorAllocation();
  }
}
